import PropTypes from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
import FooterCopyright from "../../components/footer/FooterCopyright";
import FooterNewsletter from "../../components/footer/FooterNewsletter";
import FirstColumn from "../../components/footer/FirstColumn";
import SecondColumn from "../../components/footer/SecondColumn";
import ThirdColumn from "../../components/footer/ThirdColumn";
import SocialColumn from "../../components/footer/SocialColumn";
import AetherLogo from "../../assets/img/aether.png";
import { AuthContext } from "../../common/Auth";
import { getURLHelper } from "../../helpers/url";

const FooterOne = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu,
}) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);
  const { themeSettingsData, staticPagesList, settingData } = useContext(AuthContext);
  const [menuStyleData, setMenuStyleData] = useState({});
  const [footerContent, setFooterContentData] = useState({});

  const [staticPagesListData, setstaticPagesList] = useState([]);
  useEffect(() => {
    if (staticPagesList && staticPagesList.length > 0) {
      let tempData = staticPagesList.filter((staticPage) => {
        if (staticPage.isEnabled) {
          if (staticPage.pageLocation == "footer") {
            return staticPage;
          }
        }
        return false;
      });
      setstaticPagesList(tempData);
    }
  }, [staticPagesList]);
  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      const footerMenu = themeSettingsData.find(
        (setting) => setting.settingsName === "footerMenu"
      );
      if (!footerMenu) {
        const defaultFont = settingData?.length > 0 && settingData.find(setting => setting.settingsName == "Public Store")?.values.defaultFont
        setMenuStyleData({
          menuFont: defaultFont,
        });
      } else {
        setMenuStyleData(footerMenu.values[0])
      }
      themeSettingsData.map((i) => {
        if (i.settingsName === "footerContent") {
          setFooterContentData(i.values[0]);
        }
      });
    }
  }, [themeSettingsData]);

  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  let menuAnchorStyle = {
    fontFamily: menuStyleData.menuFont,
    color: menuStyleData.menuFontcolor,
    fontSize: menuStyleData.menuFontsize + "px",
  };

  const isEnabled = (footerContent.firstColumnIsEnable && footerContent.secondColumnIsEnable && footerContent.socialLinkIsEnable && footerContent.subscribeIsEnable && footerContent.customTextIsEnable)
  const logoClass = menuStyleData.logoWidth > 500 ? 'col-lg-12 col-sm-6 col-12' : (menuStyleData.logoWidth <= 500 && menuStyleData.logoWidth > 300 ? 'col-lg-6 col-sm-6 col-12' : 'col-lg-3 col-sm-6 col-12');
  let footerWidth = sideMenu || isEnabled ? logoClass : logoClass;
  let footerContents = sideMenu || isEnabled ? (logoClass === 'col-lg-3 col-sm-6 col-12' ? '' : logoClass) : '';
  let footerWidgetRow = sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-4"
  let footerWidget = sideMenu ? "col-xl-2 col-sm-6" : "col-lg-2 col-sm-6"

  let spaceClass = {
    "pt": footerContent?.paddingTop ? footerContent.paddingTop : "pt-50",
    "pb": footerContent?.paddingBottom ? footerContent.paddingBottom : "pb-0",
    "pl": footerContent?.paddingLeft ? footerContent.paddingLeft : "pl-0",
    "pr": footerContent?.paddingRight ? footerContent.paddingRight : "pr-0",
    "mt": footerContent?.marginTop ? footerContent.marginTop : "mt-0",
    "mb": footerContent?.marginBottom ? footerContent.marginBottom : "mb-30",
    "ml": footerContent?.marginLeft ? footerContent.marginLeft : "ml-60",
    "mr": footerContent?.marginRight ? footerContent.marginRight : "mr-0"
  }


  let boxWidth = footerContent?.boxWidth ? footerContent.boxWidth : "25";
  let fullSection = footerContent?.fullSection ? "container-fluid" : "container";

  let menuULStyle = {
    backgroundColor: menuStyleData.menuBackgroundcolor,
    backgroundImage: `url(${menuStyleData.menuBackgroundImage})`,
    borderBottom:
      menuStyleData.menuBottomlineColor != ""
        ? `${menuStyleData.menuBottomlineThickness
          ? menuStyleData.menuBottomlineThickness
          : 1
        }px solid ${menuStyleData.menuBottomlineColor}`
        : "",
    borderTop:
      menuStyleData.menuToplineColor != ""
        ? `${menuStyleData.menuToplineThickness
          ? menuStyleData.menuToplineThickness
          : 1
        }px solid ${menuStyleData.menuToplineColor}`
        : "",
  };


  return (
    <footer
      style={menuULStyle}
      className={`antera-footer-section-container footer-area ${backgroundColorClass ?? ""
      } ${ menuStyleData.marginTop ?? "" } ${ menuStyleData.marginBottom ?? "" } ${ menuStyleData.marginLeft ?? "" } ${ menuStyleData.marginRight ?? ""
      } ${ menuStyleData.paddingTop ?? "" } ${ menuStyleData.paddingBottom ?? "" } ${ menuStyleData.paddingLeft ?? "" } ${ menuStyleData.paddingRight ?? "" }`}
    >
      <div className={`antera-footer-content-container ${fullSection}`}>
        <div className="d-flex flex-wrap">
          {(menuStyleData?.showLogo || menuStyleData?.poweredBy) &&
            <div
              className={footerWidth}
            >
              {/* footer copyright */}
              <FooterCopyright
                menuStyleData={menuStyleData}
                footerLogo={AetherLogo}
                spaceBottomClass="mb-30"
              />
            </div>
          }
          <div className={`footer-content ${footerContents} ${(menuStyleData?.showLogo || menuStyleData?.poweredBy) ? '' : 'w-100'}` }>
            {footerContent && footerContent.firstColumnIsEnable && (
              <FirstColumn
                menuStyleData={menuStyleData}
                footerContent={footerContent}
                order={footerContent?.firstColumnOrder}
                boxWidth={boxWidth}
                spaceClass={spaceClass}
              />
            )}
            {footerContent && footerContent.secondColumnIsEnable && (
              <SecondColumn
                menuStyleData={menuStyleData}
                footerContent={footerContent}
                order={footerContent?.secondColumnOrder}
                boxWidth={boxWidth}
                spaceClass={spaceClass}
              />
            )}

            {footerContent && footerContent.thirdColumnIsEnable && (
              <ThirdColumn
                menuStyleData={menuStyleData}
                footerContent={footerContent}
                order={footerContent?.thirdColumnOrder}
                boxWidth={boxWidth}
                spaceClass={spaceClass}
              />
            )}

            {footerContent && footerContent.socialLinkIsEnable && (
              <SocialColumn
                menuStyleData={menuStyleData}
                footerContent={footerContent}
                order={footerContent?.socialLinkOrder}
                boxWidth={boxWidth}
                spaceClass={spaceClass}
              />
            )}


            {footerContent && footerContent.customTextIsEnable && (
              <div
                className=''
                style={{order: (footerContent?.customTextOrder ? footerContent?.customTextOrder : 6)}}
              >
                <h1 className={'footer-content'}
                  dangerouslySetInnerHTML={{ __html: footerContent.customText }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="d-flex flex-wrap">
          {(menuStyleData?.showLogo || menuStyleData?.poweredBy) &&
            <div
              className={footerWidth}
            ></div>
          }
          {staticPagesListData && staticPagesListData.length > 0 && (
            <div
              className={`footer-content ${(menuStyleData?.showLogo || menuStyleData?.poweredBy) ? '' : 'w-100'}` }
            >
              <div className={`footer-widget
              ${spaceClass?.pt} ${spaceClass?.pb} ${spaceClass?.pl} ${spaceClass?.pr} ${spaceClass?.mb} ${spaceClass?.mt} ${spaceClass?.mr} ${spaceClass?.ml}`}>
                <div className="footer-title">
                  <h3
                    style={{
                      fontFamily: menuStyleData.menuFont,
                      color: menuStyleData.menuFontcolor,
                      fontSize: menuStyleData?.titleFontSize && (menuStyleData.titleFontSize + "px"),

                    }}
                  >
                    Pages
                  </h3>
                </div>
                <div className="footer-list">
                  {staticPagesListData && staticPagesListData.length > 0 && (
                    <ul>
                      {staticPagesListData &&
                        staticPagesListData.length > 0 &&
                        staticPagesListData.map((staticPage, index) => {
                          return (
                            <li key={index}>
                              <a href={getURLHelper(staticPage?.pageLink, '/page')}
                                onMouseOver={(e) => (e.target.style.color = menuStyleData.menuHovercolor)}
                                onMouseOut={(e) => (e.target.style.color = menuStyleData.menuFontcolor)}
                                style={menuAnchorStyle}>{staticPage?.pageName}
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        
        <i className="fa fa-angle-double-up"></i>
      </button>
    </footer>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
};

export default FooterOne;
